import moment, { unitOfTime } from 'moment'
import 'moment-duration-format'

export const getDuration = (amount?: number | null, units: unitOfTime.DurationConstructor = 'seconds') =>
  amount ? moment.duration(amount, units).format() : null
